var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("section", [
    _c("html", [
      _c("head"),
      _c("body", [
        _c("h1", [_vm._v("Welcome to KappaZeta agricultural monitoring app")]),
        _vm._v(" "),
        _c("p", [_c("em", [_vm._v("Version " + _vm._s(_vm.$app.version))])]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "The app let users to interactively monitor the agricultural parcels and detect farming events near real-time.\nEarth Observation (EO) data from Copernicus Sentinel satellites is particularly useful in the agricultural domain\nand opens up new possibilities for both farmers and national authorities."
          ),
        ]),
        _vm._v(" "),
        _c("h2", [_vm._v("Data sources")]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "We use Copernicus Earth observation programme Sentinel-1 and Sentinel-2 satellite data:"
          ),
        ]),
        _vm._v(" "),
        _vm._m(0),
        _vm._v(" "),
        _vm._m(1),
        _vm._v(" "),
        _c("h2", [_vm._v("Technology behind the scenes")]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "We have developed automated processing chain for Sentinel-1 and -2 satellite images\nto produce time series for several parcel-related parameters.\nUsing deep learning algorithms, our models can predict farming events with 90% accuracy."
          ),
        ]),
        _vm._v(" "),
        _c("h2", [_vm._v("Mowing chart")]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "Time series of four different parameters can be observed on mowing chart:"
          ),
        ]),
        _vm._v(" "),
        _vm._m(2),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "By clicking on NDVI time series points you can browse Sentinel-2 images over selected parcel whether in false or in true color."
          ),
        ]),
        _vm._v(" "),
        _c("p", [_vm._v("Tractor icon represents detected mowing event.")]),
        _vm._v(" "),
        _c("h2", [_vm._v("API")]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "Application can be intergrated into separate IT-system, by using well-documented API."
          ),
        ]),
        _vm._v(" "),
        _c("h2", [_vm._v("Disclaimer")]),
        _vm._v(" "),
        _vm._m(3),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("ul", [
      _c("li", [
        _c("strong", [_vm._v("Sentinel-1")]),
        _vm._v(
          " is a synthetic-aperture radar, which can acquire data in all-weather, day or night.\nSpatial resolution down to 5m and a swath width of up to 400 km."
        ),
      ]),
      _vm._v(" "),
      _c("li", [
        _c("strong", [_vm._v("Sentinel-2")]),
        _vm._v(
          " acquires optical imagery at high spatial resolution (10 m to 60 m)."
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [
      _vm._v("Background imagery and map is provided by "),
      _c("a", { attrs: { href: "http://openstreetmap.org" } }, [
        _vm._v("OpenStreetMap"),
      ]),
      _vm._v(" project."),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("ul", [
      _c("li", [
        _c("strong", [_vm._v("NDVI")]),
        _vm._v(
          " – The normalized difference vegetation index. The higher the index, the more live green vegetation the parcel contains. Calculated from Sentinel-2 images."
        ),
      ]),
      _vm._v(" "),
      _c("li", [
        _c("strong", [_vm._v("Coh VH")]),
        _vm._v(
          " – Sentinel-1 6-day repeat pass interferometric coherence in VH polarisation."
        ),
      ]),
      _vm._v(" "),
      _c("li", [
        _c("strong", [_vm._v("Coh VV")]),
        _vm._v(
          " – Sentinel-1 6-day repeat pass interferometric coherence in VV polarisation."
        ),
      ]),
      _vm._v(" "),
      _c("li", [
        _c("strong", [_vm._v("Probability")]),
        _vm._v(
          " – mowing probability as estimated with the deep learning model."
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [
      _vm._v(
        "KappaZeta does not take any responsibility for the accuracy of agricultural parcel’s geometry,\nmowing probabilities nor input data and services provided by 3"
      ),
      _c("sup", [_vm._v("rd")]),
      _vm._v(" party."),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }